import BrandModule from '@/modules/brand';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/brand/')({
  component: BrandPage,
});

function BrandPage() {
  return <BrandModule />;
}
